import { useEffect, useReducer, useRef } from "react";
import { convertTimeInput } from "../utils/convertTimeInput.js";
import { formatTime } from "../utils/formatTime.js";
import { useActions } from "./useActions/index.js";
function timePickerStateReducer(state, updateAction) {
  return { ...state, ...updateAction };
}
function createTimePickerStateInitializer(allowEmpty) {
  return (params) => {
    const { value, timeFormat } = params;
    const initialInputValue = value !== null ? formatTime(value, timeFormat) : "";
    const invalidFormat = convertTimeInput(initialInputValue, timeFormat, allowEmpty) === "invalid";
    const error = invalidFormat ? "invalidFormat" : null;
    return {
      error,
      open: false,
      timeValue: value,
      selectValue: null,
      invalidInput: invalidFormat,
      inputValue: initialInputValue
    };
  };
}
function useTimePicker(timeFormat, options, value, onChange, allowUnlistedValues, allowEmpty, disabled, inputRef) {
  const [componentState, updateComponentState] = useReducer(
    // Reducer
    timePickerStateReducer,
    // Initializer arguments
    { value, timeFormat },
    // Initializer
    createTimePickerStateInitializer(allowEmpty)
  );
  const actions = useActions({
    updateComponentState,
    allowUnlistedValues,
    componentState,
    timeFormat,
    allowEmpty,
    disabled,
    options,
    inputRef
  });
  const { timeValue, inputValue } = componentState;
  const rProps = useRef({ value, onChange });
  useEffect(() => {
    rProps.current = { value, onChange };
  }, [value, onChange]);
  useEffect(() => {
    updateComponentState({ timeValue: value });
  }, [value]);
  useEffect(() => {
    updateComponentState({
      inputValue: timeValue !== null ? formatTime(timeValue, timeFormat) : ""
    });
  }, [timeFormat, timeValue]);
  useEffect(() => {
    if (inputValue.trim() === "") {
      if (allowEmpty) {
        updateComponentState({ invalidInput: false, selectValue: null, error: null });
        return;
      }
      updateComponentState({ invalidInput: true, selectValue: null, error: "emptyField" });
      return;
    }
    const parsedInput = convertTimeInput(inputValue, timeFormat, allowEmpty);
    const isInvalid = parsedInput === "invalid" || parsedInput === null && !allowEmpty || !allowUnlistedValues && parsedInput !== null && !options.includes(parsedInput);
    const updateValue = isInvalid ? { invalidInput: true, error: "invalidFormat" } : { invalidInput: false, selectValue: parsedInput, error: null };
    updateComponentState(updateValue);
  }, [allowUnlistedValues, timeFormat, options, inputValue, allowEmpty]);
  useEffect(() => {
    if (timeValue !== rProps.current.value) {
      rProps.current.onChange(timeValue);
    }
  }, [timeValue]);
  return {
    actions,
    componentState
  };
}
export {
  useTimePicker
};
//# sourceMappingURL=useTimePicker.js.map
